<template>
  <div class="app-shell">
    <router-view />
    <a class="icp-footer" href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">湘ICP备2026047063号</a>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
.icp-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  padding: 4px 0;
  text-align: center;
  font-size: 12px;
  color: #9aa4ad;
  background: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  pointer-events: auto;
}
.icp-footer:hover {
  color: #527064;
}
</style>
